export enum MemberStats {
  WorkPlansCounts = 'activity_phase_schedule_bars_count',
  TimesheetsCount = 'time_entries_count',
  TasksCount = 'project_tasks_count',
}

export const memberStatsDataTypes = [
  MemberStats.WorkPlansCounts,
  MemberStats.TimesheetsCount,
  MemberStats.TasksCount,
];

export interface MemberStatsConfig {
  id: MemberStats;
  color: string;
  label: string;
}

export const workPlanConfig: MemberStatsConfig = {
  id: MemberStats.WorkPlansCounts,
  color: '#F3F574',
  label: 'Work Plan',
};

export const timesheetsConfig: MemberStatsConfig = {
  id: MemberStats.TimesheetsCount,
  color: '#0074d9',
  label: 'Timesheets',
};

export const tasksConfig: MemberStatsConfig = {
  id: MemberStats.TasksCount,
  color: '#25e1f0',
  label: 'Tasks',
};

export const memberStatsConfigs = {
  [MemberStats.WorkPlansCounts]: workPlanConfig,
  [MemberStats.TimesheetsCount]: timesheetsConfig,
  [MemberStats.TasksCount]: tasksConfig,
};
